import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const VIEW_TYPES = [
  { value: "on_screen", label: "On Screen" },
  { value: "pdf", label: "PDF" },
  { value: "excel", label: "Excel" },
  { value: "email", label: "Email" },
];

const ASSET_CLASSES = [
  { value: "mutual_fund", label: "Mutual Fund" },
  { value: "share_bond", label: "Share & Bond" },
];

const GROUP_BY_OPTIONS = [
  { value: "scheme_scrip", label: "Scheme/Scrip" },
  { value: "folio", label: "Folio" },
  { value: "investor", label: "Investor" },
];

const inputBorderStyle = { borderRadius: "8px", border: `1px solid ${TEAL}` };

export default function DividendReport() {
  const [viewType, setViewType] = useState("on_screen");
  const [assetClass, setAssetClass] = useState("mutual_fund");
  const [groupBy, setGroupBy] = useState("scheme_scrip");
  const [investor, setInvestor] = useState("all");
  const [dateFrom, setDateFrom] = useState("2025-02-12");
  const [dateTo, setDateTo] = useState("2026-02-12");
  const [applying, setApplying] = useState(false);

  const handleApply = () => {
    setApplying(true);
    setTimeout(() => setApplying(false), 600);
    // TODO: generate report based on filters
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h3 className="mb-2 text-primary">Dividend Report</h3>
                <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <NavLink to="/overview">Dashboard</NavLink> /
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/reports/dividend-report">Reports</NavLink> /
                    </li>
                    <li className="breadcrumb-item active">Dividend Report</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
          {/* View Type */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              View Type:
            </label>
            <div className="d-flex flex-wrap gap-3">
              {VIEW_TYPES.map((opt) => (
                <label key={opt.value} className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="viewType"
                    value={opt.value}
                    checked={viewType === opt.value}
                    onChange={() => setViewType(opt.value)}
                    style={{ accentColor: TEAL, width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Assets Class */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              Assets Class
            </label>
            <div className="d-flex flex-wrap gap-3">
              {ASSET_CLASSES.map((opt) => (
                <label key={opt.value} className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="assetClass"
                    value={opt.value}
                    checked={assetClass === opt.value}
                    onChange={() => setAssetClass(opt.value)}
                    style={{ accentColor: TEAL, width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Group By */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              Group By:
            </label>
            <div className="d-flex flex-wrap gap-3">
              {GROUP_BY_OPTIONS.map((opt) => (
                <label key={opt.value} className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="groupBy"
                    value={opt.value}
                    checked={groupBy === opt.value}
                    onChange={() => setGroupBy(opt.value)}
                    style={{ accentColor: TEAL, width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Filter */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "12px" }}>
              Filter:
            </label>
            <div className="row g-3 align-items-end">
              <div className="col-md-4">
                <label className="form-label small text-muted">Investor :</label>
                <select
                  className="form-select form-select-sm"
                  value={investor}
                  onChange={(e) => setInvestor(e.target.value)}
                  style={inputBorderStyle}
                >
                  <option value="all">All</option>
                  <option value="primary">Primary</option>
                </select>
              </div>
              <div className="col-md-8">
                <label className="form-label small text-muted d-block">Date range</label>
                <div className="d-flex align-items-center gap-2">
                  <div className="input-group input-group-sm">
                
                    <input
                      type="date"
                      className="form-control"
                      value={dateFrom}
                      onChange={(e) => setDateFrom(e.target.value)}
                      style={inputBorderStyle}
                    />
                  </div>
                  <span className="text-muted">-</span>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={dateTo}
                    onChange={(e) => setDateTo(e.target.value)}
                    style={{ ...inputBorderStyle}}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Apply */}
          <div className="d-flex justify-content-center pt-2">
            <button
              type="button"
              className="btn px-5 py-2"
              style={{
                background: TEAL,
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "15px",
              }}
              onClick={handleApply}
              disabled={applying}
            >
              {applying ? "Applying…" : "Apply"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
